import ckTheme from './cloudkitchens';
import entitiesSharedColors from './entitiesSharedColors';

const mono = '#EAA359';
const monoContrast = '#FFFFFF';
const monoDark = '#B2702C';
const monoLight = '#EAA359';

export default {
  colors: {
    ...ckTheme.colors,
    primary: monoLight,
    'primary-dark': monoDark,
    'primary-light': monoLight,
    'primary-contrast': monoContrast,
    secondary: monoDark,
    'secondary-dark': monoDark,
    'secondary-light': monoLight,
    'secondary-contrast': monoContrast,
    tertiary: mono,
    'tertiary-dark': monoDark,
    'tertiary-light': monoLight,
    'tertiary-contrast': monoContrast,
    'accent-1': monoLight,
    ...entitiesSharedColors,
  },
  fonts: {},
};
